/* eslint-disable no-underscore-dangle */
import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import HostTip_BG from '@/assets/hosttip_bg.png';
interface HostTipProps {
  meeting?: any;
  img?: string;
  title: string;
  subTitle: string;
  btn?: any;
}
export enum ERROE_CODE {
  IS_HOST_CODE = '570004',
  DISABLE_JOIN_MEETING = '511003',
}
const HostTip: React.FC<HostTipProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { img, title, subTitle, btn } = props;
    return (
      <div className={s.container}>
        <div className={s.body}>
          <div className={s.left}>
            <img src={img} className={s.img} />
          </div>
          <div className={s.right}>
            <div className={s.title}>{title}</div>
            <span className={s.subTitle}>{subTitle}</span>
            {btn && btn}
          </div>
        </div>

        <div className={s.bottom}></div>
      </div>
    );
  })
);
export default HostTip;
